import styled from "styled-components";

const BottomSection = styled.section`
  margin-top: 1rem;
`;

export default BottomSection;
